import { SerialSearchExpression } from 'src/app/shared/search-expression/serial-search-expression.model';

export class FormSearchOptionsModel extends SerialSearchExpression {
  FormId: number;
  SearchExpressions: Array<SerialSearchExpression> = [];
  public constructor() {
    super();
  }
}
